import * as api from '@/api';

export default {
    data() {
        return {
            material: {
                name: '',
            },

            submitPending: false,
            submitError: null,
        };
    },

    methods: {
        async createMaterial() {
            if (!this.$refs.materialForm.validate()) {
                return;
            }

            this.submitPending = true;
            this.submitError = null;

            const company = this.$store.state.company.id;
            const res = await api.createMaterial({ ...this.material, company });

            this.submitPending = false;

            if (res.error) {
                this.submitError = res.error.message;
                this.$awn.alert('Failed to create material');
                return null;
            }

            this.submitError = null;
            this.$awn.success('New material added');

            this.$store.dispatch('company/fetchOverview');

            return res.body;
        },
    },
};